export default "__VITE_ASSET__DlE9N86v__"